import ContentBorderedHero from "@components/V2/Heroes/Content/BorderedHero"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

//TODO this Should be moved into Storyblok interfaces
type Props = {
  backgroundColor: Storyblok.Color
  cardColor?: Storyblok.Color
  backgroundImage: Storyblok.Asset
  mobileImage: Storyblok.Asset
  cloudLogoStrip?: Storyblok.Asset
  cloudLogoStripMobile?: Storyblok.Asset
  callout: Storyblok.Callout[]
  title: string
  description: string
  richDescription: Storyblok.RichTextBlock
  primaryCTAText: string
  primaryCTALink: Storyblok.Link
  secondaryCTAText: string
  secondaryCTALink: Storyblok.Link
  hideMobileStickyButton: boolean
}

const StoryblokContentBorderedHero = ({ blok }: Storyblok.BlokProps<Props>) => {
  return (
    <ContentBorderedHero
      backgroundColor={blok.backgroundColor}
      cardColor={blok.cardColor}
      backgroundImageUrl={blok.backgroundImage?.filename ?? ""}
      backgroundImageAlt={blok.backgroundImage?.alt ?? ""}
      mobileImageUrl={blok.mobileImage?.filename}
      mobileImageAlt={blok.mobileImage?.alt}
      title={blok.title}
      description={blok.description}
      richDescription={blok.richDescription}
      primaryButtonText={blok.primaryCTAText}
      primaryButtonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      secondaryButtonText={blok.secondaryCTAText}
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink)}
      callout={blok.callout[0]}
      cloudLogoStripUrl={blok.cloudLogoStrip?.filename}
      cloudLogoStripAlt={blok.cloudLogoStrip?.alt}
      cloudLogoStripMobileUrl={blok.cloudLogoStripMobile?.filename}
      cloudLogoStripMobileAlt={blok.cloudLogoStripMobile?.alt}
    />
  )
}

export default StoryblokContentBorderedHero
